export default "__VITE_ASSET__BeIAIwps__$_?inline__"